import BREAKPOINTS from 'PotagerLogic/Enums/Breakpoints';

export const test = ({ expectedValue }) => window.innerWidth < BREAKPOINTS[expectedValue];

export default {
  type: 'screen',
  values: Object.keys(BREAKPOINTS),
  test,
};
